package com.dignicate.web.data

import com.dignicate.web.domain.*

class StaticFooterNavRepository : FooterNavRepository {
    override fun getFooterNav(): FooterNav =
        FooterNav(
            columns = listOf(
                FooterColumn(
                    title = "Services",
                    items = listOf(
                        // only "What we do" remains enabled
                        FooterItem(
                            null,
                            "What we do",
                            "/what-we-do"
                        ),
                        FooterItem(
                            null,
                            "Mobile App Development",
                            null
                        ),
                        FooterItem(
                            null,
                            "Backend / API",
                            null
                        ),
                        FooterItem(
                            null,
                            "Consulting",
                            null
                        )
                    )
                ),

                FooterColumn(
                    title = "Company",
                    items = listOf(
                        // About should point to the existing company route
                        FooterItem(
                            FooterItemKey.About,
                            "About",
                            "/company"
                        ),
                        FooterItem(
                            null,
                            "Philosophy",
                            null
                        ),
                        FooterItem(
                            FooterItemKey.Careers,
                            "Careers",
                            null
                        ),
                        FooterItem(
                            null,
                            "Contact",
                            null
                        )
                    )
                ),

                FooterColumn(
                    title = "Engineering",
                    items = listOf(
                        FooterItem(
                            FooterItemKey.GitHub,
                            "GitHub",
                            "https://github.com/dignicate",
                            LinkKind.External
                        ),
                        FooterItem(
                            null,
                            "Tech Stack",
                            null
                        ),
                        FooterItem(
                            FooterItemKey.Architecture,
                            "Architecture",
                            null
                        ),
                        FooterItem(
                            FooterItemKey.CaseStudies,
                            "Case Studies",
                            null
                        )
                    )
                ),

                FooterColumn(
                    title = "Legal",
                    items = listOf(
                        FooterItem(
                            FooterItemKey.TermsOfService,
                            "Terms of Service",
                            "/terms"
                        ),
                        FooterItem(
                            FooterItemKey.PrivacyPolicy,
                            "Privacy Policy",
                            "/privacy"
                        )
                    )
                )
            )
        )
}
